var map = {
	"./queries/taxonomies/Categories": 410,
	"./queries/taxonomies/Categories.gql": 410,
	"./queries/taxonomies/CategoriesProducts": 432,
	"./queries/taxonomies/CategoriesProducts.gql": 432,
	"./queries/taxonomies/FooterCategories": 411,
	"./queries/taxonomies/FooterCategories.gql": 411,
	"./queries/taxonomies/SpecialMenu": 433,
	"./queries/taxonomies/SpecialMenu.gql": 433,
	"./queries/taxonomies/SpecialMenuLink": 408,
	"./queries/taxonomies/SpecialMenuLink.gql": 408,
	"./queries/taxonomies/Types": 407,
	"./queries/taxonomies/Types.gql": 407
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 836;